import { isWheelSpinningSelector } from './selectors'

import type { DailyBonusInfo } from '@patrianna/shared-patrianna-types/store/AccountBonusesModule'
import type { DailyBonus } from '@patrianna/shared-patrianna-types/store/BonusesFlowModule'
import type { ReduxState } from 'store/types'

export const isTodayUTC = (year: number, month: number, day: number) => {
  const now = new Date()

  return year === now.getUTCFullYear() && month === now.getUTCMonth() && day === now.getUTCDate()
}

export const isFutureUTC = (year: number, month: number, day: number) => {
  const now = new Date()

  return year > now.getUTCFullYear() || month > now.getUTCMonth() || day > now.getUTCDate()
}

export const sortByDate = <T extends { at: string }>(items: T[]): T[] =>
  [...items].sort((a, b) => Number(new Date(a.at)) - Number(new Date(b.at)))

export const getActiveBonuses = (dailyBonuses: (DailyBonus | DailyBonusInfo)[]) => {
  return dailyBonuses.sort((a, b) => a.offset - b.offset)
}

export const getTodayBonus = (dailyBonuses: (DailyBonus | DailyBonusInfo)[]) => {
  return dailyBonuses?.find((i) => {
    return i?.eligible
  })
}

export const onWheelSpinEnd = (getState: () => ReduxState) => {
  return new Promise((res) => {
    const isWheelSpinning = isWheelSpinningSelector(getState())

    if (isWheelSpinning) {
      const pollId = setInterval(() => {
        const x = isWheelSpinningSelector(getState())

        if (!x) {
          clearInterval(pollId)
          res(null)
        }
      }, 100)
    } else {
      res(null)
    }
  })
}
